import { render, staticRenderFns } from "./VenueRecommendation.vue?vue&type=template&id=14a5fe92&scoped=true&"
import script from "./VenueRecommendation.vue?vue&type=script&lang=js&"
export * from "./VenueRecommendation.vue?vue&type=script&lang=js&"
import style0 from "./VenueRecommendation.vue?vue&type=style&index=0&id=14a5fe92&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a5fe92",
  null
  
)

export default component.exports